import TapHandIcon from '@assets/images/tap-hand-icon.svg';

/**
 * PlacementOverlay component
 * Shows "Tap to place" visual indicator during AR placement mode
 * Design based on Figma: City of Perth
 */
interface PlacementOverlayProps {
  /**
   * Optional custom message (default: "Tap To Place")
   */
  message?: string;
}

export function PlacementOverlay({ message = "Tap To Place" }: PlacementOverlayProps) {
  return (
    <div 
      className="fixed z-[20] inset-0 w-full h-full flex items-end justify-center"
      style={{ 
        pointerEvents: "none",
        paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 40px)",
      }}
    >
      <div 
        className="bg-black/75 rounded-[10px] flex items-center justify-center gap-5"
        style={{ 
          backdropFilter: "blur(6px)",
          WebkitBackdropFilter: "blur(6px)",
          width: "400px",
          maxWidth: "calc(100vw - 32px)",
          height: "112px",
          padding: "50px 50px 50px 0px",
        }}
      >
        <img 
          src={TapHandIcon} 
          alt="" 
          className="w-[67px] h-[69px] flex-shrink-0"
        />
        <p 
          className="text-white text-[28px] font-bold leading-[1.2]"
          style={{ 
            fontFamily: "'TT Commons Pro', 'Roboto', 'Poppins', sans-serif",
            letterSpacing: "0.03em",
          }}
        >
          {message}
        </p>
      </div>
    </div>
  );
}
